// Match the landlord's processing tag: only COMPLETED profiles are assessable.
export const isReportPersonProcessing = (person) =>
  person?.forensic_status !== "COMPLETED";

export const getReportDecisionPeople = (tenants) =>
  tenants.map((tenant) => ({
    ...tenant,
    gurantor_id: (tenant.gurantor_id || []).filter(
      (guarantor) => !isReportPersonProcessing(guarantor)
    ),
  }));

export const getProcessingReportApplicants = (tenants, getLabel) => {
  const people = new Map();
  tenants.forEach((tenant) => {
    [tenant, ...(tenant.gurantor_id || [])].forEach((person, index) => {
      if (!isReportPersonProcessing(person)) return;
      const id = person._id ?? person.id ?? person.tenant_id;
      people.set(String(id), {
        _id: id,
        name: getLabel(person),
        role: index === 0 ? "tenant" : "guarantor",
        isProcessing: true,
      });
    });
  });
  return [...people.values()];
};
